export enum EditViewType {
  NOTEBOOK = "notebook",
  GRAPH = "graph",
  APP = "app",
  RUN_STATS = "run-stats",
}

export const DEFAULT_VIEW: EditViewType = EditViewType.NOTEBOOK;
export const VIEW_SEPARATOR = ",";

export function parseProjectViews(rawViewParam: string | null): EditViewType[] {
  const parsedViews = (rawViewParam ?? "")
    .split(VIEW_SEPARATOR)
    .filter(isProjectViewType);

  return parsedViews.length > 0 ? parsedViews : [DEFAULT_VIEW];
}

export function serializeProjectViews(
  views: EditViewType | EditViewType[],
): string {
  return (Array.isArray(views) ? views : [views]).join(VIEW_SEPARATOR);
}

function isProjectViewType(view: string): view is EditViewType {
  return Object.values(EditViewType).includes(view as EditViewType);
}
